import { Stack } from '@mui/material'
import { FoodAvailabilityHeader } from './components/feed-availability/FoodAvailabilityHeader'
import { FoodDistributeWidget } from './components/food-distribute/FoodDistributeWidget'
import { FoodRemainedWidget } from './components/food-remained/FoodRemainedWidget'

export const FoodTableChartHeader = () => {
	return (
		<Stack direction='row' gap={8} alignItems='center'>
			<FoodAvailabilityHeader />
			{/* <FeedTableEmptyHeader /> */}
			<FoodDistributeWidget />
			<FoodRemainedWidget />
		</Stack>
	)
}
